export const headerName = {
  add: "Добавить административный район",
  edit: "Редактировать административный район",
};
export const administrativeDistrictsData = {
  section: {
    key: "section",
    label: "Наименование участка",
    type: "selectSearch",
    options: [],
    required: true,
  },
  dateStart: {
    key: "dateStart",
    label: "Дата начала действия",
    type: "date",
    required: true,
  },
  oblast: {
    key: "oblast",
    label: "Название области",
    type: "selectSearch",
    options: [],
    required: true,
  },
  dateEnd: {
    key: "dateEnd",
    label: "Дата окончания действия",
    type: "date",
  },
  rayon: {
    key: "rayon",
    label: "Название района",
    type: "selectSearch",
    options: [],
    required: true,
  },
  userid: {
    key: "userid",
    label: "Пользователь",
    type: "selectSearch",
    options: [],
    required: true,
  },
  note: {
    key: "note",
    label: "Примечание",
    type: "text",
  },
};

export const administrativeDistrictsEditData = {
  sectionName: {
    key: "sectionName",
    label: "Наименование участка",
    type: "text",
    disabled: true,
  },
  dateStart: {
    key: "dateStart",
    label: "Дата начала действия",
    type: "date",
    disabled: true,
  },
  oblastName: {
    key: "oblastName",
    label: "Название области",
    type: "text",
    disabled: true,
  },
  dateEnd: {
    key: "dateEnd",
    label: "Дата окончания действия",
    type: "date",
    required: true,
  },
  rayonName: {
    key: "rayonName",
    label: "Название района",
    type: "text",
    disabled: true,
  },
  userName: {
    key: "userName",
    label: "Пользователь",
    type: "text",
    disabled: true,
  },
  note: {
    key: "note",
    label: "Примечание",
    type: "text",
  },
};

export const setDataAdministrativeDistricts = async (prop, field) => {
  if (prop) {
    switch (field) {
      case "section": {
        administrativeDistrictsData.section.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "section",
          };
        });
        break;
      }
      case "oblast": {
        administrativeDistrictsData.oblast.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "oblast",
          };
        });
        break;
      }
      case "userid": {
        administrativeDistrictsData.userid.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "userid",
          };
        });
        break;
      }
      case "rayon": {
        administrativeDistrictsData.rayon.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "rayon",
          };
        });
        break;
      }
    }
  }
};

export const getAdministrativeDistrictsModal = () =>
  administrativeDistrictsData;

export const getAdministrativeDistrictsEditModal = () =>
  administrativeDistrictsEditData;
